/**
 * Оболочка админки (§51).
 *
 * Визуальный язык здесь другой, чем в продукте: плотные таблицы, много данных
 * на экран, мелкий шрифт. Требования §53-63 про «воздух и content-first»
 * относятся к продуктовой части — админка это рабочий инструмент.
 */
import { NavLink, Outlet } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const sections = [
  { to: '/admin', labelKey: 'admin.nav.overview', end: true },
  { to: '/admin/users', labelKey: 'admin.nav.users' },
  { to: '/admin/projects', labelKey: 'admin.nav.projects' },
  { to: '/admin/jobs', labelKey: 'admin.nav.jobs' },
  { to: '/admin/providers', labelKey: 'admin.nav.providers' },
  { to: '/admin/usage', labelKey: 'admin.nav.usage' },
  { to: '/admin/prices', labelKey: 'admin.nav.prices' },
  { to: '/admin/referrals', labelKey: 'admin.nav.referrals' },
  { to: '/admin/audit', labelKey: 'admin.nav.audit' },
];

export function AdminLayout() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-page text-content">
      <header className="border-b border-line bg-surface">
        <div className="flex items-center gap-6 px-6 py-3">
          <NavLink
            to="/"
            className="flex items-center gap-1.5 text-meta text-content-muted transition-colors duration-fast hover:text-content"
          >
            <ArrowLeft className="h-3.5 w-3.5" strokeWidth={1.75} />
            {t('admin.backToApp')}
          </NavLink>
          <span className="text-meta font-medium text-content">{t('admin.title')}</span>
        </div>

        <nav className="flex gap-1 overflow-x-auto px-4">
          {sections.map((section) => (
            <NavLink
              key={section.to}
              to={section.to}
              end={section.end}
              className={({ isActive }) =>
                `whitespace-nowrap border-b-2 px-3 py-2 text-meta transition-colors duration-fast ${
                  isActive
                    ? 'border-accent text-content'
                    : 'border-transparent text-content-secondary hover:text-content'
                }`
              }
            >
              {t(section.labelKey)}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="px-6 py-6">
        <Outlet />
      </main>
    </div>
  );
}
